<!-- <app-header-nav-bar>
    <app-header-brandlogo [ImageURL]="ImageURL"></app-header-brandlogo>
    <app-header-module-list></app-header-module-list>
    <app-header-settings (excelExportClick)="handleExportClick()"
                         (pptExportClick)="handlePPTExportClick()"
                         [helpGuide]="helpGuide"
                         [showExcel]="isCreateBtnClick"
                         [showPPT]="pptExport && (isVerticalGroupBarChartClick || isVerticalBarChartClick || isVerticalStackChartClick || isLineChartClick)"
                         [excelExport]="excelExport"
                         [repository]="repository"
                         [exportDownloads]="exportDownloads"
                         [ReportType]="reportType"
                         [pptExport]="pptExport"></app-header-settings>
  </app-header-nav-bar> -->
<app-snapshot-configuaration></app-snapshot-configuaration>

